import React from 'react';
import { HiOutlineSparkles } from 'react-icons/hi2';

/**
 * SparklesIcon
 * Ikona trblietok na zvýraznenie pozitívneho výsledku alebo stavu.
 */
const SparklesIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <HiOutlineSparkles className={className} {...props} />
);

export default SparklesIcon;

